
import gsap from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
import ScrollTrigger from 'gsap/ScrollTrigger'
import g from '../globals/variables'
import { debounce } from 'throttle-debounce'

const RecipesLines = {
  init(): void {
    if (!document.querySelector('.recipes-line')) {
      return
    }

    gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger)

    document.querySelectorAll('.recipes-line').forEach((line: HTMLElement) => {
      const isCenterLine = line.classList.contains('recipes-line--to-center')
      const isCenterToSidesLine = line.classList.contains('recipes-line--to-sides')
      const isFooterLine = line.classList.contains('recipes-line--footer')
      const isSideLine = line.classList.contains('recipes-line--to-left') || line.classList.contains('recipes-line--to-right')

      line.querySelector('path').setAttribute('vector-effect', 'non-scaling-stroke')
      // line.querySelector('svg').setAttribute('preserveAspectRatio', 'none')

      isCenterLine && this.handleCenterLine(line)
      isCenterToSidesLine && this.handleCenterToSidesLine(line)
      isFooterLine && this.handleFooterLine(line)
      isSideLine && this.handleSideLine(line)
    })

    if (document.querySelector<HTMLElement>('.recipes-category__cards')) {
      this.placeCardGridLines(document.querySelectorAll<HTMLElement>('.recipes-category__cards .recipe-card'))
      window.addEventListener('resize', debounce(100, () => {
        this.placeCardGridLines(document.querySelectorAll<HTMLElement>('.recipes-category__cards .recipe-card'))
      }))
    }

    if (document.querySelector<HTMLElement>('.recipes-brochures__cards')) {
      this.placeCardGridLines(document.querySelectorAll<HTMLElement>('.recipes-brochures__cards .brochure-card'))
      window.addEventListener('resize', debounce(100, () => {
        this.placeCardGridLines(document.querySelectorAll<HTMLElement>('.recipes-brochures__cards .brochure-card'))
      }))
    }
  },

  handleCenterLine(line: HTMLElement): void {
    line.insertAdjacentHTML('beforeend', line.querySelector('svg').outerHTML)

    line.querySelectorAll('svg').forEach((svg, index) => {
      gsap.set(svg.querySelector('path'), { drawSVG: index === 0 ? '0% 0%' : '100% 100%', overwrite: true })

      ScrollTrigger.create({
        animation: gsap.to(svg.querySelector('path'), { drawSVG: index === 0 ? '0% 50%' : '50% 100%', ease: 'none' }),
        end: '50% 50%',
        scrub: 3.4567,
        start: '50% 100%',
        trigger: line,
      })
    })
  },

  handleCenterToSidesLine(line: HTMLElement): void {
    line.insertAdjacentHTML('beforeend', line.querySelector('svg').outerHTML)
  
    line.querySelectorAll('svg').forEach((svg, index) => {
      gsap.set(svg.querySelector('path'), { drawSVG: '50% 50%', overwrite: true })
  
      ScrollTrigger.create({
        animation: gsap.to(svg.querySelector('path'), { drawSVG: index === 0 ? '0% 50%' : '50% 100%', ease: 'none' }),
        start: '50% 100%',
        end: '50% 50%',  
        scrub: 3.4567,
        trigger: line,
      })
    })
  },

  handleFooterLine(line: HTMLElement): void {
    gsap.matchMedia().add(g.breakpoints, (context) => {
      const is = context.conditions
      
      gsap.set(line.querySelector('path'), { drawSVG: '0% 0%', overwrite: true })

      ScrollTrigger.create({
        animation: gsap.to(line.querySelector('path'), { drawSVG: '0% 100%', ease: 'none' }),
        end: is.mobile ? '0% 30%' : '100% 100%',
        scrub: 3.4567,
        start: is.mobile ? '0% 90%' : '60% 100%',
        trigger: '.footer',
      })
    })
  },

  handleSideLine(line: HTMLElement): void {
    const isLeftToRight = line.classList.contains('recipes-line--to-right')
    const isRightToLeft = line.classList.contains('recipes-line--to-left')

    gsap.set(line.querySelector('path'), { drawSVG: isLeftToRight ? '0% 0%' : isRightToLeft ? '100% 100%' : '0% 100%', overwrite: true })

    ScrollTrigger.create({
      animation: gsap.to(line.querySelector('path'), { drawSVG: '0% 100%', ease: 'none' }),
      end: '50% 50%',
      scrub: 3.4567,
      start: '50% 100%',
      trigger: line,
    })
  },

  placeCardGridLines(cards): void {    
    gsap.matchMedia().add(g.breakpoints, (context) => {
      const is = context.conditions
      
      if (cards.length >= 8) {
        gsap.set('.recipes-line--1', {
          top: is.desktop ? cards[7].offsetTop + 50 : is.tablet ? cards[5].offsetTop + 100 : cards[1].offsetTop + 150,
        })
      }

      if (cards.length >= 20) {
        gsap.set('.recipes-line--5', {
          top: is.desktop ? cards[19].offsetTop + 50 : is.tablet ? cards[17].offsetTop + 100 : cards[13].offsetTop + 150,
        })
      }
    })
  },
}

export default RecipesLines
